const FEATURE_ID = 'twoFactorAuthEnterCode'
const MfaPageAnalytics = {
  screen: FEATURE_ID,
  screen_name: FEATURE_ID,
}

export const MfaScreenViewed = (previousRoute: string) => ({
  ...MfaPageAnalytics,
  object_name: 'twoFactorAuthEnterCode',
  origin: previousRoute,
})

export const ConfirmButtonTapped = (
  destinationRoute: string,
  ctaTitle: string,
) => ({
  ...MfaPageAnalytics,
  object_name: 'twoFactorAuthEnterCode',
  destination: destinationRoute,
  cta_title: ctaTitle,
})

export const InvalidCodeModalViewed = {
  ...MfaPageAnalytics,
  object_name: 'twoFactorAuthInvalid',
}

export const HelpModalViewed = {
  ...MfaPageAnalytics,
  object_name: 'twoFactorAuthHelp',
}

export const ResendButtonTapped = (ctaTitle: string) => ({
  ...MfaPageAnalytics,
  object_name: 'twoFactorAuthResend',
  cta_title: ctaTitle,
})

export const HelpButtonTapped = (ctaTitle: string) => ({
  ...MfaPageAnalytics,
  object_name: 'twoFactorAuthHelp',
  cta_title: ctaTitle,
})

export const ExpiredCodeModalViewed = {
  ...MfaPageAnalytics,
  object_name: 'twoFactorAuthSessionExpired',
}

export const TrustThisDeviceValue = (ctaTitle: string) => ({
  ...MfaPageAnalytics,
  object_name: 'trustThisDeviceInput',
  cta_title: ctaTitle,
})

const LOG_IN = 'logIn'
const loginAnalytics = {
  screen: LOG_IN,
  screen_name: LOG_IN,
}

export const logInViewed = {
  ...loginAnalytics,
  object_name: 'logIn',
}

export const logInForgotPassword = {
  ...loginAnalytics,
  object_name: 'logInForgotPassword',
}

export const logInNext = {
  ...loginAnalytics,
  object_name: 'logInNext',
}

const FORGOT_PASSWORD = 'logIn'
const forgotPasswordAnalytics = {
  screen: FORGOT_PASSWORD,
  screen_name: FORGOT_PASSWORD,
}

export const logInForgotPasswordViewed = {
  ...forgotPasswordAnalytics,
  object_name: 'logInForgotPassword',
}

export const logInForgotPasswordNext = {
  ...loginAnalytics,
  object_name: 'logInForgotPasswordNext',
}

export const logInForgotPasswordBack = {
  ...loginAnalytics,
  object_name: 'logInForgotPasswordBack',
}

export const loadingTimeLogIn = (time: number) => ({
  object_name: 'loadingTimeLogin',
  copy_content: {
    delta_seconds: time,
  },
})

export const loadingTimeLogInSuccess = (time: number) => ({
  object_name: 'loadingTimeLoginSuccess',
  copy_content: {
    delta_seconds: time,
  },
})

export const MaintenanceScreenViewed = (previousRoute: string) => ({
  screen: 'maintenance',
  screen_name: 'maintenance',
  object_name: 'maintenance',
  origin: previousRoute,
})
